export const signUpUrl = "/sign_up";
export const loginUrl = "/login";
export const OKTA_LOGOUT_URL = `${process.env.OKTA_URL}/login/signout?fromURI=${location.origin}/logout&post_logout_redirect_uri=${location.origin}`;
export const LOGOUT_URL = "/logout";
export const EDIT_PROFILE_URL = "/auth/profile/edit";
export const ORGANIZATION_SETTINGS_URL = "/auth/organization/edit";
